<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <MatrizLista
            idTipoOpex="5"
            tipoOpex="ti"
            nombreTipoOpex="TI"
            vAuthAcl="gh-pres-opex-ti"
            v-auth-acl="'gh-pres-opex-ti'"
          ></MatrizLista>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OpexTI',
  components: {
    MatrizLista: () => import('../../components/MatrizLista')
  },
  data: () => ({
    page: {
      title: 'OPEX TI'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'OPEX TI',
        disabled: false
      }
    ]
  }),
  methods: {
    open() {},
    close() {}
  }
};
</script>
